const BASE_FONT_SIZE = 16;

export const pxToRem = (px: number) => px / BASE_FONT_SIZE + 'rem';
